import { useQuery } from '@tanstack/react-query'
import { http } from '@/lib/api/client'
import type { PortalSite, Resource } from '@/lib/api/types'
import { portalMode } from '@/lib/portal'

/** On an agency's portal address: its name, logo and colour (null elsewhere). */
export function usePortalSite() {
  const query = useQuery({
    queryKey: ['portal-site'],
    enabled: portalMode,
    staleTime: Infinity,
    retry: 1,
    queryFn: async () => (await http.get<Resource<PortalSite>>('/portal-site')).data,
  })
  return portalMode ? (query.data ?? null) : null
}
